/**
 * @generated SignedSource<<3415cc51cbe35dc607f890b5c1c73e22>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type pantoneLibraryColorsContainer_colorsQuery$variables = {
  id?: string | null;
  onlyDefaultColors?: boolean | null;
  orderBy?: string | null;
  search?: string | null;
  useConversionTable?: boolean | null;
};
export type pantoneLibraryColorsContainer_colorsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"pantoneLibraryColorsContainer_colors">;
};
export type pantoneLibraryColorsContainer_colorsQuery = {
  response: pantoneLibraryColorsContainer_colorsQuery$data;
  variables: pantoneLibraryColorsContainer_colorsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "onlyDefaultColors"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "useConversionTable"
},
v5 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "id"
},
v6 = {
  "kind": "Variable",
  "name": "onlyDefaultColors",
  "variableName": "onlyDefaultColors"
},
v7 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v8 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v9 = {
  "kind": "Variable",
  "name": "useConversionTable",
  "variableName": "useConversionTable"
},
v10 = [
  {
    "kind": "Literal",
    "name": "after",
    "value": "1"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 70
  },
  (v5/*:: as any*/),
  (v6/*:: as any*/),
  (v7/*:: as any*/),
  {
    "kind": "Literal",
    "name": "paletteTypeID",
    "value": 1
  },
  (v8/*:: as any*/),
  (v9/*:: as any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "pantoneLibraryColorsContainer_colorsQuery",
    "selections": [
      {
        "args": [
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          (v8/*:: as any*/),
          (v9/*:: as any*/)
        ],
        "kind": "FragmentSpread",
        "name": "pantoneLibraryColorsContainer_colors"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v3/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v4/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "pantoneLibraryColorsContainer_colorsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v10/*:: as any*/),
        "concreteType": "PaletteColorsConnection",
        "kind": "LinkedField",
        "name": "paletteColors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PaletteColorsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PaletteColor",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v11/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "colorID",
                    "storageKey": null
                  },
                  (v12/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rgbHexCode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cmykHexCode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "spotColorName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v10/*:: as any*/),
        "filters": [
          "search",
          "id",
          "paletteTypeID",
          "onlyDefaultColors",
          "orderBy",
          "useConversionTable"
        ],
        "handle": "connection",
        "key": "pantoneLibraryColorsContainerColorsQuery_paletteColors",
        "kind": "LinkedHandle",
        "name": "paletteColors"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PalettesWithColorsConnection",
        "kind": "LinkedField",
        "name": "palettesWithColors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PalettesWithColorsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Palette",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v11/*:: as any*/),
                  (v12/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "useConversionTable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "paletteTypeID",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isZakekeDefault",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "738fac83dbbc4402b46126f4c7f13a00",
    "id": null,
    "metadata": {},
    "name": "pantoneLibraryColorsContainer_colorsQuery",
    "operationKind": "query",
    "text": "query pantoneLibraryColorsContainer_colorsQuery(\n  $id: String\n  $search: String\n  $onlyDefaultColors: Boolean\n  $orderBy: String\n  $useConversionTable: Boolean\n) {\n  ...pantoneLibraryColorsContainer_colors_3Vp9PH\n}\n\nfragment pantoneLibraryColorsContainer_colors_3Vp9PH on Query {\n  paletteColors(first: 70, after: \"1\", search: $search, id: $id, paletteTypeID: 1, onlyDefaultColors: $onlyDefaultColors, orderBy: $orderBy, useConversionTable: $useConversionTable) {\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        colorID\n        name\n        rgbHexCode\n        cmykHexCode\n        spotColorName\n        __typename\n      }\n    }\n  }\n  palettesWithColors {\n    edges {\n      node {\n        id\n        name\n        useConversionTable\n        paletteTypeID\n        isZakekeDefault\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fc5fc5541aecb9071f82a756a4b1b7f5";

export default node;
